import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useUpdateHumanReviewed } from '@/hooks/useCalls';

import type { CallWithContact } from '@repo/shared-types';

interface CallMetadataCardProps {
  call: CallWithContact;
  // Read-only viewers (clients view) can't toggle human-reviewed
  readOnly?: boolean;
}

export const CallMetadataCard = ({ call, readOnly = false }: CallMetadataCardProps) => {
  const updateHumanReviewedMutation = useUpdateHumanReviewed();
  const contact = call.contact;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">Call metadata</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <div>
          <p className="text-muted-foreground text-sm">Contact</p>
          <p className="text-sm font-medium">{contact ? contact.name : call.contact_id || 'N/A'}</p>
        </div>
        <div>
          <p className="text-muted-foreground text-sm">Phone Number</p>
          <p className="text-sm font-medium">
            {call.direction === 'INBOUND' ? call.phone_number || 'N/A' : contact?.phone || 'N/A'}
          </p>
        </div>
        <div>
          <p className="text-muted-foreground text-sm">Duration (seconds)</p>
          <p className="text-sm font-medium">{call.duration}</p>
        </div>
        <div>
          <p className="text-muted-foreground text-sm">Attempt Number</p>
          <p className="text-sm font-medium">{call.attempt_number ?? 1}</p>
        </div>
        <div>
          <p className="text-muted-foreground text-sm">Configuration</p>
          <p className="text-sm font-medium">
            {call.configuration?.name || 'Legacy Configuration'}
          </p>
          <p className="text-muted-foreground mt-0.5 text-xs break-all">
            {call.configuration_id || 'N/A'}
          </p>
        </div>
        <div>
          <p className="text-muted-foreground mb-2 text-sm">Human Reviewed</p>
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={call.human_reviewed || false}
              onChange={(e) => {
                updateHumanReviewedMutation.mutate({
                  id: call.id,
                  humanReviewed: e.target.checked,
                });
              }}
              disabled={readOnly || updateHumanReviewedMutation.isPending}
              className="text-primary focus:ring-primary h-4 w-4 cursor-pointer rounded border-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
            />
            <span className="text-sm font-medium">
              {call.human_reviewed ? 'Reviewed' : 'Not reviewed'}
            </span>
          </label>
        </div>
      </CardContent>
    </Card>
  );
};
